import { CountryLanding, MIAMI_BONUS } from "./EcuadorLandingPage";

const PERU = {
  path: "/peru",
  demonym: "peruanos",
  city: "Lima, Arequipa, Cusco, Trujillo o cualquier ciudad del Perú",
  heroImg: "https://images.unsplash.com/photo-1587595431973-160d0d94add1?crop=entropy&cs=srgb&fm=jpg&q=80&w=1920",
  heroAlt: "Machu Picchu, Perú",
  formName: "Asesoría visa Perú",
  heroOverlay: "linear-gradient(100deg, #001540f2 0%, #001540cc 40%, #0a225966 75%, #0a225926 100%)",
  bonus: MIAMI_BONUS,
};

export default function PeruLandingPage() {
  return <CountryLanding cfg={PERU} />;
}
